<div class="parser-plugin-link__body">
  <span class="icon fa-lightbulb" [style.font-size.px]="20"></span>
  {{ parserLinkDescription }}
  <a [href]="link" [target]="isExternal ? '_blank' : ''" [rel]="isExternal ? 'noopener noreferrer' : ''">
    <span class="link-text">Amadeus Content Catcher</span>
    <span class="icon fa-arrow-up-right-from-square"></span>
  </a>
</div>
